
import Vue from "vue";
import { namespace, Getter, Action } from "vuex-class";
import { storeModules } from "../../store";
import { Watch, Component } from "vue-property-decorator";
import { UpdateTabIdParamModel, TAB_VIEW_ACTIONS } from "../../store/tab-view/tab-view-types.store";
import serverErrorCodeConstant from "../../common/server-error-code.constant";

const CommonGetter = namespace(storeModules.Common, Getter);
const CommonAction = namespace(storeModules.Common, Action);
const TabViewActions = namespace(storeModules.TabView, Action);

@Component({
    template: require("./template.html")
})
export default class NotificationMessageComponent extends Vue {
    @CommonGetter notificationMessage: any
    @CommonAction setNotificationMessage: (payload) => void;
    @TabViewActions(TAB_VIEW_ACTIONS.UPDATE_TAB_IDENTIFY_ID) storeUpdateTabViewIdentifyId: (params: UpdateTabIdParamModel) => void;

    @Watch('notificationMessage')
    handleChange(val, old) {
        if (val && val !== old) {
            if (val.type === 'success') {
                this.$notify({
                    title: this.$t('SUCCESSFULLY').toString(),
                    dangerouslyUseHTMLString: true,
                    message: `<div class="notification-message-custom">${this.$t(val.action)} ${this.$t(val.module)} ${val.ref ? val.ref : ''} ${this.$t('SUCCESSFULLY')}</div>`,
                    type: 'success',
                    duration: 8500,
                    customClass: "success"
                });
            } else {
                // Validation errors render inline via <validation-summary>; skip the toast
                // to avoid showing the same failure twice on save.
                const errorCode = val.message && val.message.data && val.message.data.code;
                if (errorCode === serverErrorCodeConstant.ValidationException) return;
                const errMsg = (typeof val.message === 'string') ? val.message : (val.data && val.data.msg);
                this.$notify({
                    title: this.$t('ERROR').toString(),
                    dangerouslyUseHTMLString: true,
                    message: `<div class="notification-message-custom">${this.$t(val.action)} ${this.$t(val.module)} ${val.ref ? val.ref : ''} ${this.$t('ERROR')}</div><div>${errMsg ? this.$t(errMsg) : ''}</div>`,
                    type: 'error',
                    duration: 8500,
                    customClass: "error"
                });
            }
            this.setNotificationMessage(null);
        }
    }
}